module.exports = __webpack_public_path__ + "static/media/paytm.a461e4c9.png";